export interface Tool {
  id: string;
  name: string;
  description: string;
  image_url: string;
  target_url: string;
}

export interface ToolState {
  tools: Tool[];
  loading: boolean;
  error: string;
}

export const LOAD_TOOLS = "LOAD_TOOLS";
export const LOAD_TOOLS_SUCCESS = "LOAD_TOOLS_SUCCESS";
export const LOAD_TOOLS_FAILURE = "LOAD_TOOLS_FAILURE";

export interface LoadToolsAction {
  type: typeof LOAD_TOOLS;
}

export interface LoadToolsSuccessAction {
  type: typeof LOAD_TOOLS_SUCCESS;
  payload: Tool[];
}
export interface LoadToolsFailureAction {
  type: typeof LOAD_TOOLS_FAILURE;
  payload: string;
}

export type ToolActionTypes =
  | LoadToolsAction
  | LoadToolsSuccessAction
  | LoadToolsFailureAction;
